// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"j5-z"};